import React from 'react';
import { Message, Modal, Step } from 'semantic-ui-react';

import Button from '../../../../components/Button';
import { ActivationFormState, ActivationStep } from '../../types';

type Props = {
  open: boolean;
  onClose: () => void;
  activationStep: ActivationStep;
  lastActivationStep: number;
  activationSaving: boolean;
  activationStepError: string;
  recipientType: ActivationFormState['recipientType'];
  onBack: () => void;
  onNext: () => void;
  onFinish: () => void;
  children: React.ReactNode;
};

const ActivationWizardModal: React.FC<Props> = ({
  open,
  onClose,
  activationStep,
  lastActivationStep,
  activationSaving,
  activationStepError,
  recipientType,
  onBack,
  onNext,
  onFinish,
  children
}) => {
  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Header>Ativação de Cobranças</Modal.Header>
      <Modal.Content scrolling>
        <Step.Group fluid>
          <Step active={activationStep === 1} completed={activationStep > 1}>
            <Step.Content>
              <Step.Title>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="info circle icon" aria-hidden="true" />
                  Contexto
                </span>
              </Step.Title>
            </Step.Content>
          </Step>
          <Step
            active={activationStep === 2}
            completed={recipientType !== 'corporation' && activationStep > 2}
          >
            <Step.Content>
              <Step.Title>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="user outline icon" aria-hidden="true" />
                  Recebedor (PF)
                </span>
              </Step.Title>
            </Step.Content>
          </Step>
          <Step
            active={activationStep === 3}
            completed={recipientType === 'corporation' && activationStep > 3}
          >
            <Step.Content>
              <Step.Title>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="building outline icon" aria-hidden="true" />
                  Empresa (PJ)
                </span>
              </Step.Title>
            </Step.Content>
          </Step>
          <Step active={activationStep === 4} completed={activationStep > 4}>
            <Step.Content>
              <Step.Title>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="map marker alternate icon" aria-hidden="true" />
                  Endereço
                </span>
              </Step.Title>
            </Step.Content>
          </Step>
          <Step active={activationStep === 5}>
            <Step.Content>
              <Step.Title>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="credit card outline icon" aria-hidden="true" />
                  Conta + Revisão
                </span>
              </Step.Title>
            </Step.Content>
          </Step>
        </Step.Group>

        {activationStepError && (
          <Message negative style={{ marginTop: 16 }} role="alert" aria-live="assertive">
            {activationStepError}
          </Message>
        )}

        <div style={{ marginTop: 16 }}>{children}</div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          type="button"
          text={activationStep === 1 ? 'Cancelar' : 'Voltar'}
          light
          onClick={onBack}
          disabled={activationSaving}
        />
        {activationStep < lastActivationStep ? (
          <Button
            type="button"
            text="Próximo"
            onClick={onNext}
            disabled={activationSaving}
          />
        ) : (
          <Button
            type="button"
            text="Concluir ativação"
            onClick={onFinish}
            loading={activationSaving}
            disabled={activationSaving}
          />
        )}
      </Modal.Actions>
    </Modal>
  );
};

export default ActivationWizardModal;

